enum QueryParam {
  Translations = 'translations',
  Reciter = 'reciter',
  WBW_LOCALE = 'wbw_locale',
}

export default QueryParam;
